// extracted by mini-css-extract-plugin
export default {"badge":"vacationArchive_badge__P3JRj","btnsGroup":"vacationArchive_btnsGroup__fmtgz","status":"vacationArchive_status__1Vb-X"};